import {NodeTypeEnum} from '@/types/NodeTypeEnum'
import {StepSendEmail, StepSendPushNotification, StepSendSMS, StepSendWhatsApp} from '@/types/Steps'

type InitialSendPushConfig = Pick<StepSendPushNotification, 'message_configs' | 'haveWarnings' | 'type'>
export const initialSendPushConfig: InitialSendPushConfig = {
  haveWarnings: true,
  type: NodeTypeEnum.sendPush,
  message_configs: [
    {
      message: '',
      to: 'storeOwner',
      subject: '',
      image: undefined,
      landing_page: undefined,
    },
  ],
}

type InitialSendSMSConfig = Pick<StepSendSMS, 'message_configs' | 'haveWarnings' | 'type'>
export const initialSendSMSConfig: InitialSendSMSConfig = {
  haveWarnings: true,
  type: NodeTypeEnum.sendSMS,
  message_configs: [
    {
      message: '',
      to: 'storeOwner',
    },
  ],
}

type InitialSendWhatsAppConfig = Pick<StepSendWhatsApp, 'message_configs' | 'haveWarnings' | 'type'>
export const initialSendWhatsAppConfig: InitialSendWhatsAppConfig = {
  haveWarnings: true,
  type: NodeTypeEnum.sendWhatsApp,
  message_configs: [
    {
      id_messagetemplate: '',
      message: '',
      to: 'storeOwner',
    },
  ],
}

type InitialSendEmailConfig = Pick<StepSendEmail, 'message_configs' | 'haveWarnings' | 'type'>
export const initialSendEmailConfig: InitialSendEmailConfig = {
  haveWarnings: true,
  type: NodeTypeEnum.sendEmail,
  message_configs: [
    {
      message: '',
      to: 'storeOwner',
      subject: '',
    },
  ],
}
